export const SET_USER = "SET_USER"
export const SET_VENDOR = "SET_VENDOR"
export const SET_TRANSACTION = "SET_TRANSACTION"
export const SET_USER_ALL = "SET_USER_ALL"
